import type { CSSProperties } from 'react';
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

export interface CarouselCss extends CSSProperties {
  '--columnGap': string;
  '--gridColumns': number;
}

export const header = css`
  min-height: ${pxToRem(36)};
  position: relative;
  margin: 0 0 ${spacing.lg}px 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 0 ${spacing.xl}px 0;
    `,
  )}
`;

export const controls = css`
  display: none;
  justify-content: flex-end;
  border: none;
  padding: 0;
  margin: 0;

  ${mediaQuery(
    { min: minBreakpoints.S },
    css`
      display: flex;
    `,
  )}
`;

export const title = css`
  margin: auto;
  text-align: left;
  color: var(--neutral-black-base);

  ${mediaQuery(
    { min: minBreakpoints.S },
    css`
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      pointer-events: none;
    `,
  )}
`;

export const titleRegular = css`
  ${theme.responsiveText.HEADING.MD};
`;

export const titleSmall = css`
  ${theme.responsiveText.HEADING.SM};
`;

export const carouselContent = css`
  overflow-x: auto;
  ${/* IE and Edge */ ''}
  -ms-overflow-style: none;
  ${/* Firefox */ ''}
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-behavior: auto;
  scroll-snap-type: x mandatory;
`;

export const carouselWrapper = css`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: ${spacing.base}px 0;
  list-style-type: none;

  li {
    display: inline-block;
    scroll-snap-align: start;
    scroll-snap-stop: normal;
    ${
      /* Using margin-right because column-gap within display flex isn't supported prior to Safari 14 */ ''
    }
    margin-right: var(--columnGap);
  }

  li:last-child {
    margin-right: 0;
  }
`;

export const headerWithSubheading = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const headingGroup = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base}px;
`;

export const titleStacked = css`
  margin: 0;
  text-align: left;
  color: var(--neutral-black-base);
`;

export const subheadingLink = css`
  ${theme.responsiveText.BODY.SM};
  color: ${palette.blueBase};
  text-decoration: underline;
  text-underline-offset: 2px;
`;
